import HttpCliente from "../HttpCliente";

export const getComedianteById = (id, setComediante, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/Comediantes/${id}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {         
            if (response.status === 200) {
                if (response.data && response.data.data) {
                    setComediante(response.data.data);
                    resolve(response.data.data);
                } else {
                    setComediante(response.data);
                    resolve(response.data);
                }
            } else {
                const errorMsg = response.data?.message || "Error al obtener comediante";
                setError(errorMsg);
                reject(errorMsg);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || 
                                error.message || 
                                "Error de conexión";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * GET method - Obtiene la lista paginada de Comediantes
 * @param {Function} setComediantes función para establecer la lista de Comediantes
 * @param {Function} setError función para establecer el estado de error
 * @param {Number} page número de página
 * @param {Number} pageSize tamaño de página
 * @param {String} searchTerm término de búsqueda opcional
 * @return {Promise} Promesa de obtención
 */
export const getComediantesPaginados = (setComediantes, setError, page = 1, pageSize = 5, searchTerm = "", token) => {
    return new Promise((resolve, reject) => {
        let url = `/Comediantes/paged/habilitados?pageNumber=${page}&pageSize=${pageSize}`;
        if (searchTerm) {
            url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
        }

        HttpCliente.get(url, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setComediantes(response.data); // Establece la lista paginada de Comediantes
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message);
                reject(error.response.data.message);
            } else {
                setError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};